import styled from 'styled-components'

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const NotFoundImage = styled.img`
  margin-bottom: 10px;
  margin-top: 130px;
  width: 450px;
`

export const NotFoundHeading = styled.h1`
  color: #475569;
  font-family: 'Roboto';
  font-size: 32px;
  font-weight: bold;
  margin-bottom: -10px;
`

export const NotFoundInfo = styled.p`
  color: #64748b;
  font-family: 'Roboto';
  font-size: 18px;
  font-weight: 400;
`
